import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  createViolationSolvedItemService,
  deleteViolationSolvedItemService,
  editViolationSolvedItemService,
  getViolationSolvedItemsService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const violationSolvedAdminContext = createContext({
  violationSolvedItems: [],
  setViolationSolvedItems: () => {},
  violationSolved: {},
  setViolationSolved: () => {},
  id: "",
  setId: () => {},
  icon: "",
  setIcon: () => {},
  description: "",
  setDescription: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleShowDetailsModal: () => {},
  handleCloseDetailsModal: () => {},
  handleGetViolationSolvedItemList: () => {},
  handleCreateViolationSolvedItem: () => {},
  handleEditViolationSolvedItem: () => {},
  handleDeleteViolationSolvedItem: () => {},
});

const ViolationSolvedAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [violationSolvedItems, setViolationSolvedItems] = useState([]);
  const [violationSolved, setViolationSolved] = useState({});
  const [id, setId] = useState("");
  const [icon, setIcon] = useState("");
  const [description, setDescription] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  const handleResetState = () => {
    setId("");
    setIcon("");
    setDescription("");
  };

  // Create Violation Solved Modal Operations
  const handleShowModal = (itemValue) => {
    setIsShowModal(true);
    if (itemValue) {
      setId(itemValue.id);
      setIcon(itemValue.icon);
      setDescription(itemValue.description);
    }
  };
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  // Details Violation Solved Modal Operations
  const handleShowDetailsModal = (value) => {
    setIsShowDetailsModal(true);
    setViolationSolved(value);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    setViolationSolved({});
  };

  // Handle Get Violation Solved Item List Method
  const handleGetViolationSolvedItemList = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getViolationSolvedItemsService(objData);
      if (status === 200) {
        setViolationSolvedItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create Violation Solved Item Method
  const handleCreateViolationSolvedItem = async (event) => {
    event?.preventDefault();

    const objData = {
      icon,
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createViolationSolvedItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetViolationSolvedItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit Violation Solved Item Method
  const handleEditViolationSolvedItem = async (event) => {
    event?.preventDefault();

    const objData = {
      id,
      icon,
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editViolationSolvedItemService(objData);
      if (status === 201) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetViolationSolvedItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Violation Solved Item Method
  const handleDeleteViolationSolvedItem = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteViolationSolvedItemService(id);
      if (status === 200) {
        toastSuccessMessage(`آیتم  ${id} با موفقیت حذف شد`);
        handleGetViolationSolvedItemList();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <violationSolvedAdminContext.Provider
      value={{
        violationSolvedItems,
        setViolationSolvedItems,
        violationSolved,
        setViolationSolved,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        id,
        setId,
        icon,
        setIcon,
        description,
        setDescription,
        isShowModal,
        setIsShowModal,
        isShowDetailsModal,
        setIsShowDetailsModal,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleShowModal,
        handleCloseModal,
        handleGetViolationSolvedItemList,
        handleCreateViolationSolvedItem,
        handleEditViolationSolvedItem,
        handleDeleteViolationSolvedItem,
      }}
    >
      {children}
    </violationSolvedAdminContext.Provider>
  );
};

export default ViolationSolvedAdminContext;
